import internalKnowledgeSearchIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/internal-knowledge-search.svg';
import customerSupportExcellenceIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/customer-support-excellence.svg';
import acceleratedOnboardingIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/accelerated-onboarding.svg';
import complianceAndRiskManagementIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/compliance-and-risk-management.svg';
import salesEnhancementIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/sales-enhancement.svg';
import technicalDocsIcon from '../../../public/svg/icons/aiKnowledgeManagementSolutions/technical-docs.svg';

export const instantKnowledgeData = [
  {
    title: 'Internal Knowledge Search',
    description:
      'Give employees instant access to policies, procedures, technical documentation, and best practices. Stop the endless Slack questions and email chains.',
    icon: internalKnowledgeSearchIcon,
  },
  {
    title: 'Customer Support Excellence',
    description:
      'Power your support teams with instant access to product documentation, troubleshooting guides, and historical ticket resolutions. In seconds, not hours.',
    icon: customerSupportExcellenceIcon,
  },
  {
    title: 'Accelerated Onboarding',
    description:
      'New employees get instant answers to onboarding questions. Cut ramp-up time by 40% while reducing burden on HR and managers.',
    icon: acceleratedOnboardingIcon,
  },
  {
    title: 'Compliance and Risk Management',
    description:
      'Navigate complex regulatory requirements with AI that understands your compliance framework and audit trail documentation.',
    icon: complianceAndRiskManagementIcon,
  },
  {
    title: 'Sales Enhancement',
    description:
      'Equip sales teams with instant access to case studies, pricing details, competitive intelligence, and product specs during live conversations.',
    icon: salesEnhancementIcon,
  },
  {
    title: 'Technical Docs',
    description:
      'Engineering teams find API documentation, architecture decisions, and technical specifications in seconds. Support multi-language technical content.',
    icon: technicalDocsIcon,
  },
];
